import router from './router'
import store from './store'
// import { Message } from 'element-ui'
import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css' // progress bar style
import { initMenu } from '@/utils/menu.js'
import { getToken } from '@/utils/sessionStorageUtil.js'

NProgress.configure({ showSpinner: false }) // NProgress Configuration

const whiteList = ['/','/login', '/calogin','/calogin/manger', '/auth-redirect'] // no redirect whitelist


//路由前置守卫及权限控制
router.beforeEach(async (to, from, next) => {
  // start progress bar
  NProgress.start()
  const hasToken = getToken();
  if (hasToken) {
    initMenu(store, router);
    if (to.path === '/login') {
      next({ path: '/' })
      NProgress.done()
    } else {
      next()
      NProgress.done()
    }
  } else {
    if (whiteList.indexOf(to.path) !== -1) {
      next()
    } else {
      next(`/`)
      NProgress.done()
    }
  }
})

//
router.afterEach(() => {
  NProgress.done()
})












